import React from 'react';

import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

import {
  FluidImage,
  ModalDialog,
  ModalDialogBody,
  ModalDialogCloseButton,
  ModalDialogContent,
  ModalDialogHeader,
} from '@vp/swan';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { ZoomedDisplayData } from './ZoomedDisplayData';

export interface ZoomDialogProps {
  zoomData: ZoomedDisplayData;
  onClose: () => void;
}

export const ZoomDialog: React.FC<ZoomDialogProps> = (props) => {
  const { t } = useLocalizations();

  return (
    /* eslint-disable @vp/swan/no-deprecated  -- intentionally using deprecated props until i18n migration */
    <ModalDialog isOpen={props.zoomData.isZoomEnabled} onRequestDismiss={props.onClose}>
      <ModalDialogContent aria-labelledby="modal dialog general">
        <ModalDialogHeader marginBottom={8}>
          <ModalDialogCloseButton accessibleText={t('close')} />
        </ModalDialogHeader>
        <ModalDialogBody>
          <TransformWrapper>
            <TransformComponent>
              <FluidImage {...props.zoomData.imageProps} />
            </TransformComponent>
          </TransformWrapper>
        </ModalDialogBody>
      </ModalDialogContent>
    </ModalDialog>
    /* eslint-enable @vp/swan/no-deprecated */
  );
};
